import { render, staticRenderFns } from "./menuItemNotifications.vue?vue&type=template&id=ce8e7bce&scoped=true&"
import script from "./menuItemNotifications.vue?vue&type=script&lang=js&"
export * from "./menuItemNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8e7bce",
  null
  
)

export default component.exports